"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentForm = exports.paymentFormConfig = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const roundMoney_1 = require("../../../utils/roundMoney");
const Sub_1 = require("../../Page/Title/Sub");
const ConfirmButton_1 = require("../ConfirmButton");
const Account_1 = require("../Method/Account");
const Bank_1 = require("../Method/Bank");
const Cash_1 = require("../Method/Cash");
const Datatrans_1 = require("../Method/Datatrans");
const Transfer_1 = require("../Method/Transfer");
const MoneyLabel_1 = require("../MoneyLabel");
const PartialPayment_1 = require("../PartialPayment");
require("./index.scss");
exports.className = 'payment-form';
const paymentFormConfig = (data) => ({
    type: 'object',
    shape: {
        paymentMethod: {
            type: 'string',
        },
        partialPayment: {
            type: 'number',
            optional: true,
            roundedMoney: true,
            positive: true,
            withoutZero: true,
        },
        cash: {
            type: 'object',
            optional: true,
            modificators: (data === null || data === void 0 ? void 0 : data.paymentMethod) === 'cash' ? 'active' : undefined,
        },
        bank: {
            type: 'object',
            optional: true,
            modificators: (data === null || data === void 0 ? void 0 : data.paymentMethod) === 'bank' ? 'active' : undefined,
        },
        datatrans: {
            optional: true,
            modificators: (data === null || data === void 0 ? void 0 : data.paymentMethod) === 'datatrans' ? 'active' : undefined,
        },
        transfer: {
            type: 'object',
            optional: true,
            modificators: (data === null || data === void 0 ? void 0 : data.paymentMethod) === 'transfer' ? 'active' : undefined,
        },
        account: {
            type: 'number',
            optional: true,
            modificators: (data === null || data === void 0 ? void 0 : data.paymentMethod) === 'account' ? 'active' : undefined,
        },
    },
});
exports.paymentFormConfig = paymentFormConfig;
const PaymentForm = (props) => {
    const { priceToPay, field, transferTotal, confirm, isConfirmDisabled, } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const paymentMethodField = field(['paymentMethod']);
    const partialPaymentField = field(['partialPayment']);
    const getRemaining = () => {
        if (!partialPaymentField.value || partialPaymentField.error)
            return undefined;
        return (0, roundMoney_1.roundMoney)(priceToPay - transferTotal);
    };
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement("div", { className: `${exports.className}__container` },
            react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'dollar-circle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/Form:title', defaultMessage: 'Payment' }), modificators: 'margin-bottom-sm' }),
            react_1.default.createElement("div", { className: `${exports.className}__price-to-pay` },
                react_1.default.createElement(MoneyLabel_1.PaymentMoneyLabel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/Form:PriceToPay', defaultMessage: 'Price to pay:' }), price: priceToPay })),
            react_1.default.createElement(PartialPayment_1.PartialPayment, { ...partialPaymentField, remaining: getRemaining() }),
            react_1.default.createElement("div", { className: `${exports.className}__methods` },
                react_1.default.createElement(Cash_1.PaymentMethodCash, { ...field(['cash']), select: () => paymentMethodField.setValue('cash') }),
                react_1.default.createElement(Bank_1.PaymentMethodBank, { ...field(['bank']), select: () => paymentMethodField.setValue('bank') }),
                react_1.default.createElement(Datatrans_1.PaymentMethodDatatrans, { ...field(['datatrans']), select: () => paymentMethodField.setValue('datatrans') }),
                react_1.default.createElement(Transfer_1.PaymentMethodTransfer, { ...field(['transfer']), select: () => paymentMethodField.setValue('transfer') }),
                react_1.default.createElement(Account_1.PaymentMethodAccount, { ...field(['account']), select: () => paymentMethodField.setValue('account') })),
            react_1.default.createElement("div", { className: `${exports.className}__total-action` },
                react_1.default.createElement("div", { className: `${exports.className}__total` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/Form:TransferTotal', defaultMessage: 'Transfer total: {money}', values: {
                            money: `${(0, roundMoney_1.localizeMoney)(transferTotal, locale, 'Payment/Form/TransferTotal')} CHF`,
                        } })),
                react_1.default.createElement(ConfirmButton_1.PaymentConfirmButton, { confirm: confirm, disabled: isConfirmDisabled })))));
};
exports.PaymentForm = PaymentForm;
//# sourceMappingURL=index.js.map